import { getPrefixFromPhoneCountry } from '../../models/serializable/phone-country.js';
import { PhoneNumber } from '../../models/serializable/phone-number.js';
import { PhoneNumberFormatter } from './phone-number-formatter.js';

export class GenericPhoneNumberFormatter extends PhoneNumberFormatter {
  constructor() {
    super();
  }

  format(phoneNumber: PhoneNumber): string {
    return `${getPrefixFromPhoneCountry(phoneNumber.country)}${phoneNumber.number}`;
  }
}
